import React from 'react';
import cn from 'classnames';
import './index.css';

const { dateFormat, priceFormat } = require('@cashew/utils');

const ns = 'day-item';

export default ({
  data: {
    purchaseDate,
    totalOrders,
    totalRefunds,
    totalAmount,
    currencyCode = 'AED',
  },
}: any) => {
  const isNegative = totalAmount < 0;
  return (
    <div className={ns}>
      <div>{dateFormat({ date: purchaseDate })}</div>
      <div>{totalOrders}</div>
      <div>{totalRefunds}</div>
      <div
        className={cn(
          { [`${ns}--positive`]: !isNegative },
          { [`${ns}--negative`]: isNegative }
        )}
      >
        {priceFormat({
          currency: currencyCode,
          amount: totalAmount,
          isBalance: true,
        })}
      </div>
    </div>
  );
};
